// extracted by mini-css-extract-plugin
export default {"grid":"Gallery_grid__D5PI+","item":"Gallery_item__o-J0i","image":"Gallery_image__WGEUr","itemOverlay":"Gallery_itemOverlay__6PBGj","itemCaption":"Gallery_itemCaption__CKezS"};